/**
 * Compact remaining-time labels, e.g. "23h", "1h 30m", "45m".
 *
 * Extracted from `home.tsx`, where it was written for the Small Group card, so
 * the Open-to-chat toggle does not become a second copy that drifts. Two
 * surfaces showing "how long is left" in two different shapes is the kind of
 * inconsistency nobody files a bug about and everybody notices.
 *
 * Deliberately NOT translated, matching what the group card already ships. The
 * "h"/"m" abbreviations are read as symbols beside a numeral rather than as
 * words, they fit a button that must not wrap, and translating them would make
 * the same duration render at three different widths across locales — on a
 * control whose whole job is to stay one line. If that trade is ever revisited,
 * revisit it for both surfaces at once, which is now possible because there is
 * only one function.
 */
export function formatCompactDuration(totalMinutes: number): string {
  const mins = Math.max(0, Math.round(totalMinutes));
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
}
